"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _default = {
  'candy-apple': _colors.CANDY_APPLE,
  calypso: _colors.CALYPSO,
  koala: _colors.KOALA,
  lorax: _colors.LORAX,
  marigold: _colors.MARIGOLD,
  norman: _colors.NORMAN,
  oz: _colors.OZ,
  sorbet: _colors.SORBET,
  thunderdome: _colors.THUNDERDOME
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/core/NormalColors.js
// module id = 411
// module chunks = 5 6